import { Text } from "../text/text";
import {
  divider,
  dividerWrapper,
  labelWrapper,
  noMarginsDivider,
} from "./divider.css";

/**
 * Primary Divider component
 *
 * @example
 * <Divider />
 */

interface DividerProps {
  /**
   * Text in divider
   */
  label?: string;
  /**
   * No Margins
   */
  noMargins?: boolean;
  /**
   * Test Id
   */
  testId?: string;
}

export const Divider = ({ label, testId, noMargins = false }: DividerProps) => {
  return (
    <div className={dividerWrapper}>
      <div
        data-testid={testId}
        className={`${divider} ${noMargins ? noMarginsDivider : ""}`}
      />
      {label ? (
        <div className={labelWrapper}>
          <Text styleVariant="caption" colorVariant="secondaryText">
            {label}
          </Text>
        </div>
      ) : null}
      <div
        data-testid={testId}
        className={`${divider} ${noMargins ? noMarginsDivider : ""}`}
      />
    </div>
  );
};
